import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';
import { useAuth } from '../../../shared/useAuth.js';

const KEY = ['system', 'summary'];

export function useSystemSummary() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => {
      const { data } = await api.get('/system/summary');
      return data?.summary || {};
    },
    staleTime: 10_000
  });
}

export function useSeedDemo() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: () => api.post('/system/demo-seed').then((r) => r.data),
    successMessage: 'تم إنشاء البيانات التجريبية بنجاح',
    onSuccess: () => qc.invalidateQueries()
  });
}

export function useWipeData() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: () => api.post('/system/wipe-data', { confirm: 'مسح كامل' }).then((r) => r.data),
    successMessage: 'تم مسح جميع البيانات. تم الإبقاء على حساب المدير فقط.',
    onSuccess: () => qc.invalidateQueries()
  });
}

export function useResetSystem() {
  return useApiMutation({
    mutationFn: () => api.post('/system/reset', { confirm: 'تصفير النظام' }).then((r) => r.data),
    successMessage: 'تم تصفير النظام. سجّل الدخول بـ admin / admin123.',
    // كلمة مرور الأدمن تغيّرت والجلسات مُسحت ⇒ نسجّل الخروج ونعيد التحميل لصفحة الدخول
    onSuccess: async () => {
      try { await useAuth.getState().logout(); } catch { /* ignore */ }
      setTimeout(() => { window.location.href = '/login'; }, 600);
    }
  });
}
